import {Component, Input, OnInit} from '@angular/core';
import {NavigationOptions} from '../elements.types'
import {CardState, revealExpand} from '../../animations';

@Component({
  selector: 'as-hamburger-menu',
  templateUrl: './hamburger-menu.component.html',
  styleUrls: ['./hamburger-menu.component.scss'],
  animations: [revealExpand]
})
export class HamburgerMenuComponent implements OnInit {

  @Input() items: Array<NavigationOptions>

  state = CardState.Closed;
  constructor() {
  }

  ngOnInit() {
  }

  expandColapse(){
      this.state = (this.state == CardState.Open) ? CardState.Closed : CardState.Open;
  }

}
